import './AuroraBg.scss';

/**
 * Fixed full-viewport aurora background — three independently-drifting
 * radial gradient blobs over an obsidian base. The "drift" is pure CSS
 * keyframe; cursor parallax is layered on top via translate3d() that
 * reads `--m-cursor-x` / `--m-cursor-y` (set by useCursorParallax).
 *
 * Sits at z: var(--m-z-bg) so every section's content stacks over it.
 * Pointer-events: none so it never intercepts clicks. The grain
 * overlay (a low-alpha SVG noise) breaks up the gradient banding
 * that would otherwise show on big flat colour transitions.
 */
export function AuroraBg() {
	return (
		<div class="aurora-bg" aria-hidden="true">
			<div class="aurora-bg__grid" />
			<div class="aurora-bg__blob aurora-bg__blob--a" />
			<div class="aurora-bg__blob aurora-bg__blob--b" />
			<div class="aurora-bg__blob aurora-bg__blob--c" />
			<div class="aurora-bg__grain" />
			<div class="aurora-bg__vignette" />
		</div>
	);
}
